export default __webpack_public_path__ + "static/article-6-ab1b60ea41a1b72c24135ea161e89755.jpg";